module.exports = __webpack_public_path__ + "img/countDown.9bc257b1.gif";